import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class PermitTagService {
    private readonly baseUrl = `${environment.API_GATEWAY_URL}/permit/admin/permit-tag`;

    constructor(private http: HttpClient) {}

    getTags(): Observable<string[]> {
        return this.http.get<string[]>(this.baseUrl);
    }

    deleteTag(tag: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${encodeURIComponent(tag)}`);
    }
}
